module.exports = __webpack_public_path__ + "media/images/payments/skrill-50a191d6b7131b337080a64f8f5c6c2b.svg";